var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#12428A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4008 11.6C13.3021 11.6 11.6008 13.3014 11.6008 15.4C11.6008 17.4987 13.3021 19.2 15.4008 19.2C17.4995 19.2 19.2008 17.4987 19.2008 15.4C19.2008 13.3014 17.4995 11.6 15.4008 11.6ZM10.8008 15.4C10.8008 12.8595 12.8603 10.8 15.4008 10.8C17.9413 10.8 20.0008 12.8595 20.0008 15.4C20.0008 17.9406 17.9413 20 15.4008 20C12.8603 20 10.8008 17.9406 10.8008 15.4Z",
    fill: "#12428A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0859 18.0871C18.2421 17.9309 18.4954 17.9309 18.6516 18.0871L21.0816 20.5172C21.2378 20.6734 21.2378 20.9266 21.0816 21.0828C20.9254 21.2391 20.6721 21.2391 20.5159 21.0828L18.0859 18.6528C17.9297 18.4966 17.9297 18.2433 18.0859 18.0871Z",
    fill: "#12428A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.4a35a174.svg";
export { ForwardRef as ReactComponent };